import { render } from "./AdsSettings.vue?vue&type=template&id=1f2610a3&scoped=true"
import script from "./AdsSettings.vue?vue&type=script&lang=js"
export * from "./AdsSettings.vue?vue&type=script&lang=js"

import "./AdsSettings.vue?vue&type=style&index=0&id=1f2610a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2610a3"]])

export default __exports__